import React, {Component} from 'react';
import { 
  Link, 
  withRouter 
} from 'react-router-dom';

import { PageSettings } from '../../config/page-settings.js';
import LogoSBMS from '../../assets/images/logoSBMS.png';
import LogoArtajasa from '../../assets/images/artajasa.png';
import VideoBG from '../../assets/videos/login-video-bg.mp4';


import withNotification from '../../components/HOCNotification/HOCNotification.component';
// import Auth from '../../services/auth';
import { RESPONSE, COPYRIGHT } from '../../config/constants';
import Services from '../../services/service';

// const auth = new Auth();
const { SUCCESS, FAILED } = RESPONSE;

class ForgotPassword extends Component {
	static contextType = PageSettings;

	constructor(props) {
    super(props);
    this.state = {
      isForgotPassword: true,
      email: '',
      oldPassword: '',
      newPassword: '',
      registrationCode: '',
      validatePassword: true,
      message: ''
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }
  
	componentDidMount() {
		this.context.handleSetPageSidebar(false);
		this.context.handleSetPageHeader(false);
		this.context.handleSetBodyWhiteBg(true);
	}

	componentWillUnmount() {
		this.context.handleSetPageSidebar(true);
		this.context.handleSetPageHeader(true);
		this.context.handleSetBodyWhiteBg(false);
	}

  handleFieldChange = (key) => (e) => {
    const state = { [key]: e.target.value };
    this.setState(state);
  }
	
	handleSubmit(event) {
		event.preventDefault();
    this.setState({ isForgotPassword: false });
  }

  handleSubmitEmail = (e) => {
    e.preventDefault();
    const payload = {
      username: this.state.email
    };

    Services.postForgotPassword(payload)
      .then(res => {
        this.props.addNotification('success', 'Success', 'Please check your email for new registration code', 'top-right');
        this.setState({isForgotPassword: false})
      })
      .catch(err => {
        this.props.addNotification('danger', 'Failed', 'Oops something went wrong !', 'top-right');
      });
  }

  handleSubmitVerify = (e) => {
    e.preventDefault();
    const { oldPassword, newPassword, email, registrationCode } = this.state;

    if(oldPassword !== newPassword) {
      this.setState({ validatePassword: false, message: 'is-invalid' });
      return;
    } else {
      this.setState({ validatePassword: true, message: 'is-valid' });
    }

    const payload = {
      username: email,
      securityCode: registrationCode,
      newPassword: newPassword
    };

    Services.postVerifyPassword(payload)
      .then(res => {
        this.props.addNotification('success', 'Success', 'Please login with your new password', 'top-right');
        this.setState({isForgotPassword: false})
        setTimeout(window.location.replace('/user/login'));
      })
      .catch(err => {
        this.props.addNotification('danger', 'Failed', 'Oops something went wrong !', 'top-right');
      });
  }

  toggleNotification = action => {
    switch(action){
      case SUCCESS:
        this.props.addNotification('success', 'Success', 'Login successfull', 'top-right');
        break;
      case FAILED:
        this.props.addNotification('danger', 'Failed', 'Oops something went wrong !', 'top-right');
        break;
      default:
        break;
    }
  };

  renderFormForgotPassword = () => (
    <div className="login-content">
      <form className="margin-bottom-0" onSubmit={this.handleSubmitEmail}>
        <div className="form-group m-b-15">
          <input type="email" value={this.state.email} className="form-control form-control-lg" onChange={this.handleFieldChange('email')} placeholder="Email Address" required />
        </div>
        <div className="login-buttons">
          <button className="btn btn-success btn-block btn-lg">Reset Password</button>
        </div>
        <div className="m-t-20 m-b-40 p-b-40 text-inverse text-center">
          Back to <Link to="/user/login" className="text-success">Login</Link>.
        </div>
        <hr />
        <p className="text-center text-grey-darker">
          {COPYRIGHT}
        </p>
        <div className="text-center">
          <img src={LogoArtajasa} alt="logo_artajasa" width={"64px"}/>
        </div>
      </form>
    </div>
  );

  renderFormChangePassword = () => {
    const { oldPassword, newPassword, registrationCode, message } = this.state;

    return (
      <div className="login-content">
        <form className="margin-bottom-0" onSubmit={this.handleSubmitVerify}>
          <div className="form-group m-b-15">
            <input type="password" value={oldPassword} className="form-control form-control-lg" onChange={this.handleFieldChange('oldPassword')} placeholder="New Password" required />
          </div>
          <div className="form-group cus m-b-15">
            <input type="password" value={newPassword} className={`form-control form-control-lg ${message}`} onChange={this.handleFieldChange('newPassword')} placeholder="Verify Password" required />
            <div className="invalid-feedback">Please input same password</div>
          </div>
          <div className="form-group m-b-15">
            <input type="text" value={registrationCode} className="form-control form-control-lg" onChange={this.handleFieldChange('registrationCode')} placeholder="OTP" required />
          </div>
          <div className="login-buttons">
            <button className="btn btn-success btn-block btn-lg">Submit</button>
          </div>
          <hr />
          <p className="text-center text-grey-darker">
            {COPYRIGHT}
          </p>
          <div className="text-center">
            <img src={LogoArtajasa} alt="logo_artajasa" width={"64px"}/>
          </div>
        </form>
      </div>
    );
  }
  
	render() {
		return (
			<div className="login login-with-news-feed">
				<div className="news-feed">
        <div className="news-image login-cover">
            <video className="video-bg" autoPlay muted loop>
              <source src={VideoBG} type="video/mp4"/>
            </video>
            <div className="login-cover-bg"></div>
          </div>
          <div className="news-caption">
            <h4 className="caption-title">SIMPONI - ARTAJASA</h4>
            <p>Sistem Monitoring Perangkat Operasional Dan Infrastruktur</p>
					</div>
				</div>
				<div className="right-content">
					<div className="login-header">
						<div className="brand">
							<img src={LogoSBMS} alt="logo_sbms"></img>
							<small></small>
						</div>
						<div className="icon">
							<i className="fa fa-sign-in"></i>
						</div>
					</div>
          {this.state.isForgotPassword ? this.renderFormForgotPassword() : this.renderFormChangePassword() }
				</div>
			</div>
		)
	}
}

export default withNotification(withRouter(ForgotPassword));